import ArticleCardHome from 'Components/article_card_home'
import ErrorPlaceholder from '@fdn/error_placeholder'
import {handleUrlArticle} from 'Helpers/utils'

const PopularArticleDesktop = ({ dataPopular, is_mobile }) => {
  return (
    <div className="popular-article section">
      <div className="section-title-wrapper">
        <h3 className="section-title">Popular Article</h3>
      </div>
      {Array.isArray(dataPopular) ? (
        dataPopular.length ? (
          <div className="popular-article-wrapper">
            {dataPopular.map((item, idx) => (
              <div id={`id_popular_article_${idx + 1}`} key={idx}>
                <ArticleCardHome
                  numbering={idx + 1}
                  is_mobile={is_mobile}
                  is_sponsored={false}
                  font_title={`Josefin Sans, sans-serif`}
                  article={Object.assign({
                    category: { name: item.category_slug },
                    date: item.created_at,
                    title: item.title,
                    text: item.excerpt,
                    image: item.image,
                    url: handleUrlArticle(item.url),
                    author: { fullname: item.author.name },
                  })}
                  url_author={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/author/${item.author.username}`}
                  type={'type-3'}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="popular-article-wrapper single">
            <ErrorPlaceholder
              is_mobile={is_mobile}
              icon="https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/editorial/no-data-icon.svg"
              icon_alt="no data icon female daily"
              title="Sorry :("
              text="There’s no data to display"
            />
          </div>
        )
      ) : (
        <div className="popular-article-wrapper single">
          <ErrorPlaceholder
            is_mobile={is_mobile}
            icon="https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/editorial/something-wrong-icon.svg"
            icon_alt="wrong icon female daily"
            title="Uh Oh!"
            text="Something went wrong"
          />
        </div>
      )}
      <style>
        {`
          .popular-article.section {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 12px;
          }

          .popular-article-wrapper {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-gap: 40px;
          }

          .popular-article-wrapper.single {
            grid-template-columns: 1fr;
            grid-gap: 0px;
          }

          .article-card-desktop-type-3 .article-content p.numbering {
            color: #DFE3E8;
            margin-top: 8px;
          }

          .fdn-article-card-desktop-type-3 .article-content .article-title a.title-anchor {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3; 
            -webkit-box-orient: vertical;
          }
        `}
      </style>
    </div>
  )
}

export default PopularArticleDesktop
